module.exports = __webpack_public_path__ + "img/alipay-pay-example.4646da17.jpg";